<template>
  <div class="account">

    <el-button type="primary" size="small" class="addBtn" @click="showDialog('add')">添加账号</el-button>
    <el-table :data="list" row-key="id" :fit="true" style="width: 100%"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
      <el-table-column label="编号" prop="id" min-width="60"></el-table-column>
      <el-table-column label="账号" prop="username" min-width="120" class="table-text"></el-table-column>

      <el-table-column label="企业" prop="corp" min-width="120" class="table-text">
        <template slot-scope="scope">
          <span :title="scope.row.corp">
            {{ scope.row.corp ? scope.row.corp : '--' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="角色" prop="role" min-width="120" class="table-text"></el-table-column>
      <el-table-column label="是否启用" prop="status" min-width="100" class="table-text">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 10">启用</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>

        </template>
      </el-table-column>

      <el-table-column label="操作日期" prop="updated_at" width="180px"></el-table-column>

      <el-table-column label="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="scope.row.id != 1" type="primary" size="small" class="editBtn"
            @click="showDialog('edit', scope.row.id)">编辑</el-button>
        </template>
      </el-table-column>

    </el-table>

    <!-- 分页 -->
    <el-pagination @current-change="pageChange" :current-page.sync="pager.page" :page-size="pager.pagesize"
      hide-on-single-page prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" :total="pager.count">
    </el-pagination>

    <!-- 新增、修改弹窗 -->
    <el-dialog :title="(oper == 'add' ? '新增' : (oper == 'edit' ? '修改' : '')) + '账号'" :visible.sync="isAlert"
      width="600px" :before-close="formCancel" :close-on-click-modal="false">
      <div class="dialog-title" slot="title">
        {{ (oper == 'add' ? '新增' : (oper == 'edit' ? '修改' : '')) + '账号' }}
      </div>
      <el-form :model="formData" :rules="rules" :hide-required-asterisk="false" ref="form">
        <el-form-item label="账号" prop="username">
          <el-input :maxlength="20" v-model="formData.username"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input :maxlength="20" v-model="formData.password" :placeholder="oper == 'edit' ? '不填写则不修改' : ''"
            onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"></el-input>
        </el-form-item>
        <el-form-item label="所属角色" prop="role">
          <el-select v-model="formData.role" class="qjc-wid-100">
            <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>



        <el-form-item label="是否启用" prop="status">
          <el-radio v-model="formData.status" label="10">启用</el-radio>
          <el-radio v-model="formData.status" label="0">禁用</el-radio>
        </el-form-item>

      </el-form>

      <div class="dialog-footer">
        <el-button @click="formCancel" class="cancel-btn">取消</el-button>
        <el-button @click="formSubmit" class="submit-btn">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { Base64 } from "js-base64";
import { isPhone, isEmail } from "@/utils"
import { admin, adminRole, } from "@/utils/axios"

export default {
  name: 'adminAccount',
  data () {
    var passwordVerify = (rule, value, callback) => {
      if (this.oper == 'add') {// 新增必填
        if (value == '') {
          callback(new Error('密码必填'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    }

    var phoneVerify = (rule, value, callback) => {
      if (value != '') {
        if (isPhone(value)) {
          callback();
        } else {
          callback(new Error('请输入正确格式的手机号'));
        }
      } else {
        callback();
      }
    }

    var emailVerify = (rule, value, callback) => {
      if (value != '') {
        if (isEmail(value)) {
          callback();
        } else {
          callback(new Error('请输入正确格式的邮箱'));
        }
      } else {
        callback();
      }
    }

    return {
      isAlert: false,
      oper: '',

      list: [],// 用户列表

      formData: {
        username: '',
        password: '',
        realname: '',// 真实姓名
        phone: '',
        email: '',
        role: '',
        status: '0',
        company_id: '',
      },
      rules: {
        username: [
          { required: true, message: '账户名必填', trigger: 'blur' }
        ],
        role: [
          { required: true, message: '角色必选', trigger: 'change' }
        ],
        password: [
          { required: true, validator: passwordVerify, trigger: 'blur' }
        ],
        phone: [
          { validator: phoneVerify, trigger: 'blur' }
        ],
        email: [
          { validator: emailVerify, trigger: 'blur' }
        ],
        status: [
          { required: true, message: '是否启用', trigger: 'change' }
        ]
      },

      roles: [],// 角色列表
      companyList: [],

      pager: {
        page: 1,
        pagesize: 12,
        count: 0
      }

    }
  },
  watch: {
    'formData.username': {
      handler (val) {
        if (val) {
          this.formData.username = val.replace(/\s+/g, "")
        }

      },
      deep: true,
      immediate: true
    },
    'formData.password': {
      handler (val) {
        if (val) {
          this.formData.password = val.replace(/\s+/g, "")
        }

      },
      deep: true,
      immediate: true
    },

  },
  mounted () {
    this.$nextTick(() => {
      this.getList();
    })
  },
  methods: {
    // 获取列表
    getList () {
      admin(this.pager).then(res => {
        if (res.code == 200) {
          const data = JSON.parse(Base64.decode(res.data))
          this.list = data.data;
          this.pager = data.pager;
          // 数值可能为字符串，需转换为number
          for (var key in this.pager) {
            this.pager[key] = parseInt(this.pager[key]);
          }
        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg
          });
        }
      });
    },

    pageChange (page) {
      this.pager.page = page;
      this.getList();
    },

    // 参数：修改(edit)或添加(add)
    showDialog (oper, id) {
      this.oper = oper;
      this.isAlert = true;
      // 获取角色列表
      adminRole({ act: 'role' }).then(res => {
        if (res.code == 200) {
          const data = JSON.parse(Base64.decode(res.data))
          this.roles = data;
        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg
          });
        }
      });


      if (oper == 'add' && this.formData.id) {// 新增
        this.$refs.form.resetFields();// 重置表单
      } else if (oper == 'edit') {// 修改
        admin({
          act: 'detail',
          id: id
        }).then(res => {
          if (res.code == 200) {
            const data = JSON.parse(Base64.decode(res.data))
            this.formData = data;
          } else {
            this.$myAlert({
              type: 'fail',
              title: res.msg
            });
          }
        });
      }
    },

    formCancel () {
      this.isAlert = false;
      this.$refs.form.resetFields();// 重置表单
    },

    formSubmit () {
      this.$refs.form.validate(isSuc => {
        if (isSuc) {
          const formData = JSON.parse(JSON.stringify(this.formData))
          let actv = 'update'
          if (this.oper == 'add') {// 新增去除id
            formData.id ? delete formData.id : '';
            actv = 'add'
          }
          formData.act = actv
          admin(formData).then(res => {
            if (res.code == 200) {
              this.getList();// 更新列表
              this.isAlert = false;

              this.$myAlert({
                type: 'success',
                content: (this.oper == 'add' ? '添加' : '修改') + '成功'

              });
            } else {
              this.$myAlert({
                type: 'fail',
                content: res.msg
              });
            }
          });
        }
      });
    },

    remove () {
      this.$myAlert({
        title: '确定删除？',
        callback: () => {// 点击确认触发
        }
      });
    }
  }
}
</script>

<style scoped>
.el-dialog .el-form>>>.el-form-item__label {
  width: 80px;
  padding-right: 0;
  margin-left: 4%;
  text-align: left;
}

.el-dialog .el-form>>>.el-form-item__content {
  float: left;
  width: 60%;
  margin-right: 0;
}



.account>>>.el-table__header-wrapper {
  border-radius: 4px;
}



.el-dialog .el-form>>>.el-form-item {
  margin-bottom: 8px;
}

.el-dialog .el-form>>>.el-input {
  width: 432px;
}

.el-dialog .el-form>>>.el-input__inner {
  width: 432px;
  height: 34px;
  line-height: 34px;
}
</style>
<style lang="scss" scoped>
.account {
  height: 100%;
  padding: 28px 24px;

  .add {
    padding: 8px 12px;
    margin: 24px 0 12px;
    color: #fff;
  }

  .add-action {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 15px;

    .add-action-img {
      display: flex;
      align-items: center;
      align-items: center;
      width: 24px;
      height: 24px;
      background-color: #6883FB;
      border-radius: 50%;

      &::after {
        content: "+";
        width: 100%;
        font-size: 20px;
        color: #fff;
        text-align: center;
        margin-bottom: 4px;
      }
    }

    .add-action-text {
      font-size: 14px;
      color: #6883FB;
      margin-left: 8px;
    }
  }

  .el-table {
    i[class^=el-icon] {
      margin-right: 16px;
      cursor: pointer;
    }

    span.on,
    span.off {
      position: relative;
      display: inline-block;
      line-height: 14px;
      padding: 8px 12px;
      border-radius: 24px;
      color: #525866;
    }

    span.on {
      &::before {
        position: absolute;
        left: 0;
        top: 12px;
        content: "";
        width: 6px;
        height: 6px;
        background-color: #67C23A;
        border-radius: 50%;
      }
    }

    span.off {
      &::before {
        position: absolute;
        left: 0;
        top: 12px;
        content: "";
        width: 6px;
        height: 6px;
        background-color: #FF5219;
        border-radius: 50%;
      }
    }
  }

  .el-pagination {
    text-align: center;
    margin-top: 32px;
  }

  .el-dialog {
    .dialog-title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #293033;
      text-align: center;
    }

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;

      .cancel-btn {
        width: 94px;
        height: 34px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #6883FB;
        border: 1px solid #6883FB;
        border-radius: 17px;
        background-color: #fff;
      }

      .submit-btn {
        width: 94px;
        height: 34px;
        font-size: 14;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff;
        border: none;
        border-radius: 17px;
        background-color: #6883FB;
        margin-left: 16px;
      }

      .el-button {
        padding: 9px 15px;
      }
    }
  }
}

.addChildMenus {
  margin-right: 12px;
  color: #6883FB;
  float: left;
  cursor: pointer;
}
</style>
